module.exports = __webpack_public_path__ + "img/square_logo.3feb62db.png";